export const convertToReadableDate = (date) => new Date(date).toLocaleString('nl-NL', { year: 'numeric', month: 'long', day: 'numeric' })
